import { ISnackbarModel } from '../types';
import { SnackbarsStackAction, SNACKBARS_STACK_ADD_UPDATE } from './types';

export const addUpdateSnackbar = (
  snackbar: ISnackbarModel
): SnackbarsStackAction => ({
  type: SNACKBARS_STACK_ADD_UPDATE,
  payload: snackbar
});
